<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <TablePicker v-model="value.parameter1" title="Data Table" />
      </v-col>
      <v-col cols="12">
        <ServerFieldValueListEditor
          title="Target Columns"
          v-model="value.values"
          :table="value.parameter1"
        />
      </v-col>
      <v-col cols="12">
        <DataOutputPicker
          title="Output (Id)"
          v-model="value.parameter2"
          :workflow="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../../ui/shared/TablePicker.vue";
import ServerFieldValueListEditor from "../../ui/shared/ServerFieldValueListEditor.vue";
import DataOutputPicker from "../../ui/shared/DataOutputPicker.vue";

export default {
  name: "InsertRowDesigner",

  components: { TablePicker, ServerFieldValueListEditor, DataOutputPicker },

  props: ["value"],
};
</script>